import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import modal from 'store/app/ui/modals/acknowledgment/preview/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    acknowledgmentPreviewModal: bindActionCreators(modal, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
